import {FetcherOptions} from '../../axios/axiosBffFetch';
import type {ProfileApiResultVo} from '../../common/shared/api/nicolas/vo/UserVo.interface';
import {UserAndCashQueryVariables} from '../../graphql/generated/types';
import {postGatewayUserGetProfile} from '../user/postGatewayUserGetProfile';

export async function getAccountUser(
  variables?: UserAndCashQueryVariables,
  options?: FetcherOptions
): Promise<ProfileApiResultVo> {
  return postGatewayUserGetProfile(variables, options);
}
